import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class Notices {
    constructor() {
        this.sections = document.querySelectorAll('.notices');
        this.years = document.querySelectorAll('.notices-item');
        
        this.ready();
    }
    
    ready() {

        this.sections.forEach(section => {
            
            const select = section.querySelector('select')
            const years = section.querySelectorAll('.notices-item')
            
            years.forEach(year => {
                const ano = year.dataset.ano;
                var opt = document.createElement('option');
                opt.value = ano;
                opt.innerHTML = ano;
                select.appendChild(opt);
    
                year.addEventListener('click', () => {
                    year.classList.toggle('active')
                })
            })

            select.addEventListener('change', () => {
                if(select.value != 0) {
                    years.forEach(yearCheck => {
                        if(yearCheck.dataset.ano != select.value) {
                            yearCheck.classList.add('hidden')
                        } else {
                            yearCheck.classList.remove('hidden')
                        }
                    })
                } else {
                    years.forEach(yearCheck => {
                        yearCheck.classList.remove('hidden')
                    })
                }
            })

        })

    }

}

if (document.querySelector('.notices')) {
    new Notices();
}
